import React from 'react';
import countryCodes from '@constants/countryCodes.json';
import SimpleReactSelect from '../formElements/SimpleReactSelect';
import cn from 'classnames';
import Styles from './index.module.scss';

const PhoneNumberComponent = ({
  countryCode, styles, handleCountryCodeChange, maxMenuHeight, isHeight, onSelect = () => {},
  isCustomWidth = 'col-3', ShowLandscapeMode, QRLink, swipedDown, GuestInformationPhone, isPhoneNumber, isReceiptPopUp
}) => {

  const options = countryCodes.map((code) => {
    return (
      { name: `${code.code} (+${code.dialCode})`, id: code.dialCode, code: code.code }
    );
  });
  const sortedOptions = options.sort((a, b) => {
    if (a.code.toLowerCase() < b.code.toLowerCase()) return -1;
    if (a.code.toLowerCase() > b.code.toLowerCase()) return 1;
    return 0;
  });
  return (
    <div className={cn('position-absolute  p-0', isCustomWidth, !QRLink && Styles.countryCodeZIndex)} style={{ ...styles }}>
      <SimpleReactSelect
        options={sortedOptions}
        isHeight={isHeight}
        onSelect={onSelect}
        onChange={handleCountryCodeChange}
        maxMenuHeight={maxMenuHeight}
        defaultValue={countryCode}
        className={cn("fs-12 h-100 w-100", GuestInformationPhone ? "color-white" : "od-text-secondary text-secondary")}
        customStyles={cn(Styles.select)}
        ShowLandscapeMode={ShowLandscapeMode}
        QRLink = {QRLink}
        swipedDown = {swipedDown}
        GuestInformationPhone = {GuestInformationPhone}
        isPhoneNumber = {isPhoneNumber}
        isReceiptPopUp={isReceiptPopUp}
      />
    </div>
  );
};

export default PhoneNumberComponent;
